export default "__VITE_ASSET__DEKIURtz__"